import { useContext } from "react";

import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useUpdateFileAndInvalidateHistoryQueries } from "@/queries/refetch-files-and-history";
import { ProjectContext } from "@/stores/project-provider";
import { ProjectFileOrDirectory } from "@/types/api-model-simple-names";

export const deleteFileOrDirectory = async (projectId: string, item: ProjectFileOrDirectory) => {
  const { id, type } = item;
  return await getRanaApiV1().FilesApi[
    type === "file" ? "projectFileDelete" : "projectDeleteDirectory"
  ]({
    projectId,
    path: id,
  });
};

export const deleteFilesOrDirectories = async (
  projectId: string,
  items: ProjectFileOrDirectory[]
) => {
  return await Promise.all(items.map((item) => deleteFileOrDirectory(projectId, item)));
};

export const useDeleteProjectFileOrDirectory = (items: ProjectFileOrDirectory[]) => {
  const { id: projectId } = useContext(ProjectContext);
  const updateFileAndInvalidateHistoryQueries = useUpdateFileAndInvalidateHistoryQueries();

  return useMutationWithErrorHandler(async () => {
    const files = await deleteFilesOrDirectories(projectId, items);
    const promises = files.map((_, idx) =>
      updateFileAndInvalidateHistoryQueries({ beforeId: items[idx].id, file: null })
    );
    await Promise.all(promises);
  });
};
